export type { SegmentBlockProps } from "./types";
export { default as WLSegmentBlock } from "./SegmentBlock.vue";
